import { useEffect, useState, React, useMemo, useCallback, useRef } from "react";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { Col, Container, Row } from "react-bootstrap";
import withoutAuth from "../../services/withoutAuthProvider";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { format } from "date-fns";
import { SkeletonJadwal } from "../../components/Skeleton/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { actionsPage } from "../../redux/page.slice";

import InfiniteScroll from "react-infinite-scroll-component";
import Time from "../../assets/icons/Time";
import Location from "../../assets/icons/Location";
import { id } from "date-fns/esm/locale";
import ArrowRight from "../../assets/icons/ArrowRight";
import { subdomainSelector } from "../../redux/subdomain.slice";

import { formatSimpleDateRange } from "../../helpers/dateRangeFormatter";
import CardRibbon from "../../components/CardUnit/CardRibbon";

const toastError = (message) => {
  return toast.error(message, {
    id: "error-message",
    duration: 3000,
  });
};

export default function LiveLelang() {
  const subdomain = useSelector(subdomainSelector);
  const dispatch = useDispatch();
  const today = format(new Date(), "yyyy");
  const { push, location } = useHistory();
  const dataPrev = location?.state?.dataFilter;
  const isMountedRef = useRef(true);
  const queryClient = useQueryClient();

  const { search: searchParams } = useLocation();
  const parameters = new URLSearchParams(searchParams);
  const auction_id = parameters.get("auction_id");

  const years = [
    {
      id: 1,
      name: `${today - 3} - ${today}`,
    },
    {
      id: 2,
      name: `${today - 7} - ${today - 4}`,
    },
    {
      id: 3,
      name: `${today - 11} - ${today - 8}`,
    },
    {
      id: 4,
      name: `${today - 15} - ${today - 12}`,
    },
    {
      id: 5,
      name: `Dibawah ${today - 16}`,
    },
  ];
  const silinders = [
    {
      id: 1,
      name: "Kurang dari 1000 cc",
    },
    {
      id: 2,
      name: "1001 cc - 1300 cc",
    },
    {
      id: 3,
      name: "1301 cc - 1600 cc",
    },
    {
      id: 4,
      name: "1601 cc - 2000 cc",
    },
    {
      id: 5,
      name: "Lebih dari 2000 cc",
    },
  ];

  // filtering state
  let iniitialFilterValue = {
    unit_maker_id: dataPrev?.unit_maker_id || "",
    unit_model_id: dataPrev?.unit_model_id || "",
    unit_model_type_id: dataPrev?.unit_model_type_id || "",
    unit_type_id: dataPrev?.unit_type_id || "",
    year: dataPrev?.year || "",
    location_id: dataPrev?.location_id || "",
    unit_segment_id: dataPrev?.unit_segment_id || "",
    year_start: "",
    year_end: "",
    engine_capacity_start: "",
    engine_capacity_end: "",
    auction_id: auction_id || dataPrev?.auction_id || "",
    grade: dataPrev?.grade || "",
    start_auction_date: format(new Date(), "yyyy-MM-dd"),
    sort_order: dataPrev?.sort_order || "",
    tag_id: dataPrev?.tag_id || "",
    start_base_price: dataPrev?.start_base_price || "",
    end_base_price: dataPrev?.end_base_price || "",
  };
  const [search] = useState(dataPrev?.search || "");
  const [filterValue, setFilterValue] = useState({ ...iniitialFilterValue });
  const [filterTag, setFilterTag] = useState([]);

  const resetFilter = () => {
    if (!isMountedRef.current) return;

    setFilterTag([]);
    setFilterValue({
      search: "",
      unit_maker_id: "",
      unit_model_id: "",
      unit_model_type_id: "",
      unit_type_id: "",
      year: "",
      location_id: "",
      unit_segment_id: "",
      auction_id: "",
      year_start: "",
      year_end: "",
      engine_capacity_start: "",
      engine_capacity_end: "",
      grade: "",
      start_auction_date: "",
      sort_order: "",
      tag_id: "",
      start_base_price: "",
      end_base_price: "",
    });
  };

  const removeTag = (idx) => {
    if (!isMountedRef.current) return;

    const foundData = filterTag.find((a, b) => b === idx);
    const name = foundData.name;
    setFilterValue((prev) => ({
      ...prev,
      [name]: "",
    }));
    setFilterTag((prev) => prev.filter((el) => el.name !== name));
  };

  const generateYear = (id) => {
    let final = {};
    if (id !== "") {
      const foundYear = years.find((a) => a.id === parseInt(id));
      const this_year = foundYear?.name?.split(" ");
      if (foundYear.id === 5) {
        final.year_end = this_year[1];
      } else {
        final.year_start = this_year[0];
        final.year_end = this_year[2];
      }
    }
    return final;
  };

  const generateSilinder = (id) => {
    const foundCC = silinders.find((a) => a.id === parseInt(id));
    let final = {};
    if (foundCC) {
      const this_cc = foundCC.name.split(" ");
      if (foundCC.id === 5 || foundCC.id === 1) {
        final.engine_capacity_start = this_cc[2];
      } else {
        final.engine_capacity_start = this_cc[0];
        final.engine_capacity_end = this_cc[3];
      }
      return final;
    }
  };

  const processFilterParams = (currentFilters) => {
    const params = {};
    Object.keys(currentFilters).forEach((key) => {
      if (currentFilters[key] !== "") {
        if (key === "year") {
          const final = generateYear(currentFilters[key]);
          Object.assign(params, final);
        } else if (key === "engine_capacity") {
          const final = generateSilinder(currentFilters[key]);
          Object.assign(params, final);
        } else {
          params[key] = currentFilters[key];
        }
      }
    });
    return params;
  };

  const {
    data: queryData,
    fetchNextPage,
    hasNextPage,
    isLoading: loading,
  } = useInfiniteQuery(
    ["liveLelang", filterValue, subdomain, dataPrev?.isTimeBid, auction_id, search],
    async ({ pageParam = 1 }) => {
      // Check if component is still mounted before making API call
      if (!isMountedRef.current) {
        throw new Error("Component unmounted");
      }

      const filterParams = processFilterParams(filterValue);
      const params = {
        ...filterParams,
        page: pageParam,
        page_size: dataPrev?.isTimeBid ? 12 : 500,
      };

      if (subdomain !== "global") {
        params.exclusive_seller_slug = subdomain;
      }

      if (auction_id) {
        params.auction_id = auction_id;
      }

      const response = await withoutAuth.getDataWithoutAuth("/api/auction?status=STARTED,PENDING", params);

      // Check again after async operation
      if (!isMountedRef.current) {
        throw new Error("Component unmounted");
      }

      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch auctions");
    },
    {
      getNextPageParam: (lastPage) => {
        // Check if component is still mounted
        if (!isMountedRef.current) {
          return undefined;
        }

        if (lastPage?.current_page < lastPage?.last_page) {
          return lastPage.current_page + 1;
        }
        return undefined;
      },
      keepPreviousData: false, // Disable keep previous data untuk menghindari cache
      enabled: isMountedRef.current, // Only run query if component is mounted
      retry: false, // Disable retry untuk menghindari multiple calls setelah unmount
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnMount: true, // Enable refetch on mount untuk data terbaru
      cacheTime: 0, // Hilangkan cache - data tidak disimpan setelah unmount
      staleTime: 0, // Data langsung dianggap stale - selalu fetch data baru
      onError: (err) => {
        if (isMountedRef.current && err.message !== "Component unmounted") {
          toastError(err.message);
        }
      },
    }
  );

  const data = useMemo(() => queryData?.pages.flatMap((page) => page.data) || [], [queryData]);

  // Wrap fetchNextPage dengan mounted check
  const safeFetchNextPage = useCallback(() => {
    if (isMountedRef.current && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage]);

  const convertQueryParams = useCallback(() => {
    if (!isMountedRef.current) return;

    if (location?.search !== "") {
      const currentParams = new URLSearchParams(location?.search);
      const searchParams = {};
      for (const [key, value] of currentParams) {
        if (key !== "page_size" && value !== "null") {
          searchParams[key] = value;
        }
      }

      setFilterValue((data) => {
        return {
          ...data,
          ...searchParams,
        };
      });
    }
  }, [location?.search]);

  useEffect(() => {
    convertQueryParams();
  }, [convertQueryParams]);

  // Cleanup effect to prevent memory leaks
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;

      // Cancel all queries untuk component ini saat unmount
      queryClient.cancelQueries(["liveLelang"]);

      // Hapus cache untuk query ini
      queryClient.removeQueries(["liveLelang"]);
    };
  }, [queryClient]);

  return (
    <div>
      <Container>
        <div className="d-flex justify-content-end"></div>
        {filterTag.length !== 0 ? (
          <Row>
            <Col span={12}>
              <div className="tag-filter-unit">
                <div
                  className="d-inline cursor-pointer"
                  onClick={resetFilter}
                  style={{
                    textDecoration: "none",
                    fontWeight: "bold",
                    padding: "8px",
                  }}
                >
                  <span>Reset</span>
                </div>
                {filterTag.map((filter, idx) => (
                  <span className="tag" key={`filter-${idx}`}>
                    {filter?.label}
                    <span className="cursor-pointer" onClick={() => removeTag(idx)}>
                      <svg
                        style={{ marginLeft: "8px" }}
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.99999 4.05734L8.29999 0.757339L9.24266 1.70001L5.94266 5.00001L9.24266 8.30001L8.29999 9.24267L4.99999 5.94267L1.69999 9.24267L0.757324 8.30001L4.05732 5.00001L0.757324 1.70001L1.69999 0.757339L4.99999 4.05734Z"
                          fill="#9AA2B1"
                        />
                      </svg>
                    </span>
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <InfiniteScroll
          dataLength={data.length}
          next={safeFetchNextPage}
          hasMore={!!hasNextPage && isMountedRef.current}
          loader={<p>Loading...</p>}
          className="row mt-3"
          style={{ overflow: "hidden" }}
        >
          {loading ? (
            new Array(12).fill(1).map((el, indx) => (
              <div className="col-6 col-md-3 col-xl-2 mb-4" key={`unit-${indx}`}>
                <SkeletonJadwal />
              </div>
            ))
          ) : data.length > 0 ? (
            <>
              {data.map((item, idx) => {
                return (
                  <div className="col-6 col-md-3 col-xl-2 mb-4" key={`unit-live-${idx}`}>
                    <div
                      className={`card-unit-jadwal h-100 cursor-pointer ${item?.status === "STARTED" ? "live" : ""}`}
                      onClick={() => {
                        if (item?.auction_category === "CLOSE-BID") {
                          if (item?.is_exclusive && subdomain === "global") {
                            console.log("cc");
                            const url = `https://${item?.exclusive_seller_slug}.${window.location.hostname}/unit-lelang`;
                            window.open(url);
                          } else {
                            console.log("b");
                            dispatch(actionsPage.setPage({ page: 0 }));
                            push("/unit-lelang", {
                              dataFilter: {
                                auction_id: item?.id,
                                unit_type_id: item?.unit_type?.id,
                                isTimeBid: item?.auction_category === "CLOSE-BID",
                              },
                            });
                          }
                        } else if (item?.auction_category === "TIME-BID") {
                          dispatch(actionsPage.setPage({ page: 0 }));
                          push("/unit-lelang", {
                            dataFilter: {
                              auction_id: item?.id,
                              unit_type_id: item?.unit_type?.id,
                              isTimeBid: item?.auction_category === "TIME-BID",
                            },
                          });
                        } else {
                          push("/live-auction/" + item?.id);
                        }
                      }}
                    >
                      {item?.status === "STARTED" ? <CardRibbon auctionCategory={item?.auction_category} /> : ""}
                      <div className="card-unit-jadwal-header overflow-hidden">
                        <img
                          className="card-unit-jadwal-image"
                          src={item?.unit_type?.banner_url}
                          alt="..."
                          loading="lazy"
                        />
                        <div className="position-absolute mt-2 m-2">
                          {item?.auction_category === "TIME-BID" ? (
                            <span className="badge time-bid">Time Bid</span>
                          ) : item?.auction_category === "CLOSE-BID" ? (
                            <span className="badge close-bid">Close Bid</span>
                          ) : (
                            <span className="badge online-bid">Online Bid</span>
                          )}
                        </div>
                      </div>

                      <div className="card-unit-jadwal-body d-flex flex-column">
                        <div
                          style={{
                            height: "50px",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <h5 className="card-unit-jadwal-title">{item?.name || "-"}</h5>
                        </div>
                        {item?.auction_category !== null ? (
                          item?.date_start && item?.date_finish && item?.date_start !== item?.date_finish ? (
                            <div className="card-unit-jadwal-date">
                              {formatSimpleDateRange(item?.date_start, item?.date_finish)}
                            </div>
                          ) : (
                            <div className="card-unit-jadwal-date">
                              {format(new Date(item?.date_finish), "dd MMM yyyy", { locale: id })}
                            </div>
                          )
                        ) : (
                          <div className="card-unit-jadwal-date">
                            {format(new Date(item?.date_start), "dd MMM yyyy", { locale: id })}
                          </div>
                        )}
                        <div className="card-unit-jadwal-time d-flex">
                          <Time />
                          <span>{`${item?.time_start?.substr(0, 5)} - ${item?.time_finish?.substr(0, 5)} WIB`}</span>
                        </div>
                        <div className="card-unit-jadwal-location d-flex">
                          <Location />
                          <span> {item?.location?.name || "-"}</span>
                        </div>
                        <div className="card-unit-jadwal-footer mt-4" style={{}}>
                          <span
                            className="cursor-pointer"
                            style={{
                              display: "table - cell",
                              verticalAlign: "middle",
                              marginRight: "10px",
                            }}
                            onClick={() => {
                              if (item?.auction_category === "TIME-BID") {
                                dispatch(actionsPage.setPage({ page: 0 }));
                                push("/unit-lelang", {
                                  dataFilter: {
                                    auction_id: item?.id,
                                    unit_type_id: item?.unit_type?.id,
                                    isTimeBid: item?.auction_category === "TIME-BID",
                                  },
                                });
                              } else {
                                push("/live-auction/" + item?.id);
                              }
                            }}
                          >
                            Lihat Detail
                          </span>{" "}
                          <ArrowRight />
                        </div>
                      </div>
                    </div>
                    {/* <CardUnitJadwal
                      auctionCategory={item?.auction_category}
                      tanggalAkhir={item?.date_finish}
                      id={item?.id}
                      judul={item?.name || "-"}
                      tanggal={item?.date_start}
                      waktu={`${item?.time_start?.substr(
                        0,
                        5
                      )} - ${item?.time_finish?.substr(0, 5)} WIB`}
                      lokasi={item?.location?.name || "-"}
                      // live={item?.is_started}
                      onClick={() => {
                        push("/live-auction/" + item?.id);
                      }}
                      unit_type_image={item?.unit_type?.banner_url}
                    /> */}
                  </div>
                );
              })}
            </>
          ) : (
            <div className="text-center text-secondary mt-5">Unit lelang tidak ditemukan</div>
          )}
        </InfiniteScroll>
      </Container>
    </div>
  );
}
